export default function RemoveTrailingSlash(url) {
   if (url && url[url.length - 1] === '/') {
      return url.slice(0, -1);
   }
   return url;
}
